export default {
  "content": "<path d=\"M7 7H4a1 1 0 00-1 1v8l.005.102A1 1 0 004 17h3v2H4a3 3 0 01-2.996-2.846L1 16V8a3 3 0 013-3h3v2zM17 5a3 3 0 013 3v8a3 3 0 01-3 3h-3v-2h3a1 1 0 001-1V8a1 1 0 00-1-1h-3V5h3zM10.5 15a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM23.5 14.5h-2v-5h2v5zM11.5 13h-2V6h2v7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};